import { NewClassCommentActionTypes } from './new-class-comment.types';

export const toggleNewClassCommentPageHidden = () => ({
    type: NewClassCommentActionTypes.TOGGLE_CLASS_COMMENT_PAGE_HIDDEN
});

export const classCommentMessage = classMessage => ({
    type: NewClassCommentActionTypes.CLASS_COMMENT_MESSAGE,
    payload: classMessage,
});